import useGroupData from './useGroupData'
import useGroupDataUpdate from './useGroupDataUpdate'

export default function useMetadata() {
  const {
    group: { metadata },
  } = useGroupData()
  const dispatch = useGroupDataUpdate()

  function setArchivalReferenceNumber(archivalReferenceNumber) {
    updateMetadata({ archivalReferenceNumber })
  }

  function setLanguages(languages) {
    updateMetadata({ languages })
  }

  function setTitle(title) {
    updateMetadata({ title })
  }

  function setVolume(volume) {
    updateMetadata({ volume })
  }

  function setCreator(creator) {
    updateMetadata({ creator })
  }

  function updateMetadata(fieldObj) {
    dispatch({ type: 'SET_METADATA', value: { ...metadata, ...fieldObj } })
  }

  function resetCreatorCheckboxes() {
    dispatch({ type: 'SET_CREATOR_CHECKBOXES', value: [] })
  }

  return {
    metadata,
    setArchivalReferenceNumber,
    setLanguages,
    setTitle,
    setVolume,
    setCreator,
    updateMetadata,
    resetCreatorCheckboxes,
  }
}
